import { DOMAIN_STATUS_COLORS, DOMAIN_STATUS_LABELS } from '@/types/sendingDomains'

interface DomainStatusBadgeProps {
  status?: string | null
  className?: string
}

/** Verification status pill for both overall domain status and per-record status. */
export function DomainStatusBadge({ status, className = '' }: DomainStatusBadgeProps) {
  const key = status || 'NotStarted'
  const color = DOMAIN_STATUS_COLORS[key] || DOMAIN_STATUS_COLORS.NotStarted
  const label = DOMAIN_STATUS_LABELS[key] || key
  return (
    <span className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${color} ${className}`}>
      {label}
    </span>
  )
}
